import { Injectable } from '@angular/core';

import { AppState } from '../app-state';

import { pathViewSchema, pathViewPullQueryBuilder } from '../schema/path-view-schema';
import { RxDocument } from 'rxdb';
import { TestbedRxdbGraphQlCollectionService } from './testbed-rxdb/testbed-rxdb-graphql-collection.service';
import { PathView } from '../models';
import { TestbedRxdbState } from './testbed-rxdb/testbed-rxdb-state';
import { AuthenticationService } from './authentication.service';

export type PathViewDoc = RxDocument<PathView,{}>

@Injectable({ providedIn: 'root' })
export class PathViewService extends TestbedRxdbGraphQlCollectionService<PathView,PathViewDoc> {

    constructor( appState : AppState, authService: AuthenticationService, rxdbState: TestbedRxdbState ) {
        super('path_view', pathViewSchema, appState, rxdbState, authService)
        this.syncConfig = {
            push: false,
            pull: true,
            intervalMs: appState.settings.get('rxdb.collections.path_view.intervalMs',0),
            retry: true,
            bGraphQL: true,
            query: pathViewPullQueryBuilder(),
            graphQLSubscription: 
            `subscription{
                pathViewUpdated{
                    pathView{
                        id
                    }
                }
            }`
        }
    }    
}